import Flickity from 'flickity';
import imagesloaded from 'flickity-imagesloaded'; // eslint-disable-line no-unused-vars

export default () => {
    const gallery = document.querySelectorAll('.product-carousel__items');

    const initialize = (el) => {
        const next = el.parentNode.parentNode.querySelector('.product-carousel__next');

        let grouping = 4;

        if (window.innerWidth <= 400) {
            grouping = 1;
        } else if (window.innerWidth <= 768) {
            grouping = 2;
        } else if (window.innerWidth <= 1024) {
            grouping = 3;
        }

        const flkty = new Flickity(el, {
            cellAlign: 'left',
            contain: true,
            prevNextButtons: false,
            pageDots: true,
            wrapAround: false,
            adaptiveHeight: false,
            imagesLoaded: true,
            resize: true,
            groupCells: grouping,
        });

        next.addEventListener('click', () => {
            flkty.next();
        });

        return flkty;
    };

    for (const el of gallery) {
        const flkty = initialize(el);

        // Hide dots if we don't have anything ofscreen
        if (flkty && flkty.slides.length === 1) {
            el.querySelector('.flickity-page-dots').style.display = 'none';
            el.parentNode.querySelector('.product-carousel__next').style.display = 'none';
        }
    }
};
